import { staticMediaUrl } from '@/fo/util/image-loader';

export const IPHONE_IMAGES = {
  desktopFullHD: staticMediaUrl('article/page/where-to-buy/iPhone_17_1920.png'),
  desktopHD: staticMediaUrl('article/page/where-to-buy/iPhone_17_1440.png'),
  laptop: staticMediaUrl('article/page/where-to-buy/iPhone_17_1200.png'),
  tablet: staticMediaUrl('article/page/where-to-buy/iPhone_17_768_1.png'),
  mobile: staticMediaUrl('article/page/where-to-buy/iPhone_17_375_1.png')
};
